/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-concat */
/* eslint-disable @typescript-eslint/no-this-alias */
import axios from 'axios';
import { mockPostCreditRequestData } from '../test/mock/mockPostCreditRequestData';
import { mockGetAirportListData } from '../test/mock/mockGetAirportListData';

const JWTToken = localStorage.getItem('session-token');
const vbzDebug = localStorage.getItem('vbzDebug');

async function postCreditRequest(requestApiBody: any, apiDomain: string) {
  const newRequestBody = JSON.stringify(requestApiBody);
  const smilesGetAttendancesUrl = `${apiDomain}/voebiz-airlines-retro-credit/v1`;
  if (vbzDebug) {
    return { data: mockPostCreditRequestData };
  }
  return axios
    .post(smilesGetAttendancesUrl, newRequestBody, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      if (response.data.status === 'Points in processing') {
        response.data.status = 'Points processed';
        return { data: response.data };
      }
      if (response.data.status === 'Points processed') {
        response.data.status = 'Points in processing';
        return { data: response.data };
      }
      return { data: response.data };
    })
    .catch((error) => {
      return error;
    });
}

async function getAirportList(description: any, airportDomainApi: string) {
  const smilesGetAttendancesUrl = `${airportDomainApi}/v1/airports?size=50&q=(description:*${description}*)`;
  if (vbzDebug) {
    return mockGetAirportListData;
  }
  try {
    const response = await axios.get(smilesGetAttendancesUrl);
    return response.data;
  } catch (error) {
    return [];
  }
}

function concatAirportDescription(airport: any, descriptionTemplate1: any) {
  if (descriptionTemplate1 === true) {
    // eslint-disable-next-line no-useless-concat
    return `${airport.city}, ${airport.country} (${airport.code})`;
  }
  // eslint-disable-next-line no-useless-concat
  return `${airport.city}, ${airport.country}, ${airport.name} (${airport.code})`;
}

function handleAirportList(data: any, description: string) {
  let handled: any = [];
  const listTemp: any = [];

  let airportList;

  if (data && data.length > 0 && data[0].code) {
    // order result Brasil
    data.forEach((item: any) => {
      item.order = item.country === 'Brasil' ? 2 : 3;

      if (!item.name.includes('Todos os Aeroportos')) {
        listTemp.push(item);
      }

      if (item.name.includes('Todos os Aeroportos') && item.code === 'DXB') {
        listTemp.push(item);
      }
    });
    // esta organizando por ordem alfabética pelo nome do Aeroporto
    listTemp.sort(function (a1: any, a2: any) {
      const cmp = a1.order - a2.order;
      if (cmp === 0) {
        const n1 = a1.name;
        const n2 = a2.name;
        // eslint-disable-next-line no-nested-ternary
        return n1 < n2 ? -1 : n1 > n2 ? 1 : 0;
      }
      return cmp;
    });

    airportList = listTemp;
    const descriptionTemplate1: any = {};
    airportList.forEach((item: any) => {
      const isSALorZSA = item.code === 'SAL' || item.code === 'ZSA';
      const hasDescription = descriptionTemplate1[item.city] !== undefined;
      descriptionTemplate1[item.city] = isSALorZSA && hasDescription;
      item.description = concatAirportDescription(item, descriptionTemplate1[item.city]);
    });
  } else if (data && data.airportList && data.airportList.length > 0) {
    data.airportList[0].airport
      .filter((item: any) => !item.name.includes('Todos os Aeroportos'))
      .forEach((item: any) => listTemp.push(item));

    airportList = listTemp;
  }

  if (airportList?.length) {
    const first = airportList
      .filter((item: any) => description?.toUpperCase() === item.code)
      .map((item: any) => ({
        id: item.code,
        label: item.description,
        value: `${item.city} (${item.code})`,
      }));
    handled = airportList
      .filter((item: any) => description?.toUpperCase() !== item.code)
      .map((item: any) => ({
        id: item.code,
        label: item.description,
        value: `${item.city} (${item.code})`,
      }));
    handled.unshift(...first);
  } else {
    handled.push({
      label: `Aeroporto ${description} não encontrado `,
      value: description,
    });
  }
  return handled;
}

export { postCreditRequest, getAirportList, handleAirportList };
